export const SMS_SKELETONS = "/api/pa/Reference/SmsTemplates"
export const SMS_SKELETON = "/api/pa/Reference/SmsTemplate/:param"
